import React, { Component } from "react";
import { MenuButton } from "./Menu-style";



export default class MenuItem extends Component {

   render() {
      return (
         <div>
            <MenuButton href="https://www.google.by/">
               {this.props.name}

            </MenuButton>
         </div>

      )
   }
}